import React                                                             from 'react';
import { Group, Stack, Text }                                            from '@mantine/core';
import useIsMounted                                                      from '@hooks/use-is-mounted';
import { IconBath, IconBed, IconHotelService, IconMoonStars, IconRuler } from '@tabler/icons';
import { formatTitle, formatTitleNoS }                                   from '@utils/dxb-utils';
import { Details, Settings }                                             from '../../../../generated/graphql';
import useStyles                                                         from './BasicDetailsTitle.styles';


interface Props {
    details: Details;
    settings?: Settings;
}

export const BasicDetailsTitle: React.FC<Props> = ({ details,  settings}) => {

    const { classes } = useStyles();
    const isMounted = useIsMounted();


    // TODO: Separate the label from number so we can do hidden xs for the label here
    return isMounted && (

        <Group className={classes.xxsGapGroup} position="left" mb={20}>
            <Stack align="left">
                <Text className={classes.features}>
                    <IconBed className={classes.icon} size={30} stroke={1}/>
                    {/*<span className={classes.textHidden}>{formatTitle(details?.bed_rooms, 'Bedroom')}</span>*/}
                    <span className={classes.textNumber}>{details?.bed_rooms}</span>
                    <span className={classes.textHidden}>{formatTitle(details?.bed_rooms, 'Bedroom')}</span>
                </Text>
            </Stack>

            <Stack align="left">
                <Text className={classes.features}>
                    <IconBath className={classes.icon} size={26} stroke={1.1}/>
                    {/*<span className={classes.textHidden}>{formatTitle(details?.bath_rooms, 'Bathroom')}</span>*/}
                    <span className={classes.textNumber}>{details?.bath_rooms}</span>
                    <span className={classes.textHidden}>{formatTitle(details?.bath_rooms, 'Bathroom')}</span>
                </Text>
            </Stack>

            <Stack align="left">
                <Text className={classes.features}>
                    <IconHotelService className={classes.icon} size={26} stroke={1.1}/>
                    {/*<span className={classes.textHidden}>{formatTitle(details?.max_occupancy, 'Guest')}</span>*/}
                    <span className={classes.textNumber}>{details?.max_occupancy}</span>
                    <span className={classes.textHidden}>{formatTitle(details?.max_occupancy, 'Guest')}</span>
                </Text>
            </Stack>

            <Stack align="left">
                <Text className={classes.features}>
                    <IconRuler className={classes.icon} size={26} stroke={1.1}/>
                    <span className={classes.textNumber}>{details?.size}</span>
                    <span>m²</span>
                </Text>
            </Stack>

            <Stack align="left">
                <Text className={classes.features}>
                    <IconMoonStars className={classes.icon} size={26} stroke={1.1}/>
                    <span className={classes.textNumber}>{settings?.minimumNights}</span>
                    <span className={classes.textHidden}>{formatTitleNoS(settings?.minimumNights, 'Nights Minimum')}</span>
                </Text>
            </Stack>

        </Group>

    )

}
